import { render, staticRenderFns } from "./Exercices.vue?vue&type=template&id=52ebe88c"
import script from "./Exercices.vue?vue&type=script&lang=js"
export * from "./Exercices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports